import React from 'react'
import styled from 'styled-components'
import logo from '../../static/images/logo-long-yellow.png'
import grayLogo from '../../static/images/logo-long-gray.png'

const StyledAroundSchoolsLogo = styled.img`
  height: 38px;
  width: 110px;
`

interface IAroundSchoolsLogoProps {
  isGray?: boolean
}

const AroundSchoolsLogo: React.FC<IAroundSchoolsLogoProps> = ({
  isGray = false,
}) => (
  <StyledAroundSchoolsLogo alt="ArundSchools" src={isGray ? grayLogo : logo} />
)

export { AroundSchoolsLogo }
